import "./body.css";
import {selectedData} from "./selected.js";

const Body = () => {
    return ( 
        <>
            <div className="full-body">
                {/* <h1>Hey there!</h1>
                <h1>
                    <Typewriter
                        cursor
                        cursorStyle="|"
                        typeSpeed={100}
                        words={["Results will be announced on 14 March."]}
                    />
                </h1><br/> */}
                <div className="congo">
                    <p>Congratulations!</p><br/>
                    <p>We are glad to inform that you are now a part of SIAM-VIT</p><br/>
                </div>
            </div>
            {/* <div className="stay">Stay Tuned!</div> */}
            <div className="Results">
                {/* <table>
                {selectedData.map((slide)=>{
                    return(
                            <tr>
                                <td>{slide.name}</td>
                                <td>{slide.reg}</td>
                            </tr>
                    )
                })}
                </table> */}
                {selectedData.map((slide)=>{
                    return(
                            <p>{slide.name} ({slide.reg})</p>
                    )
                })}
            </div>
        </>
     );
}
 
export default Body;
